import React from "react";
import { Badge } from "@caesars-ui/core";

const headers = ["Principle", "Status", "Description"];

const TableRow = ({ children }) => (
  <div className="py-4 border-b-1 border-solid border-fg-minimal flex items-center">
    {children}
  </div>
);

const Principle = ({principle, status, children}) => {
  const formatStatus = (status) => {
    if (!status) return "--";
    return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
  };
  
  return (<>
    <TableRow>{principle}</TableRow>
    <TableRow><div className="flex">{!status ? "--" : <Badge status={status === "ready" ? "positive" : status === "planned" ? "info" : undefined} type={status === "partially ready" ? "subtle" : undefined} text={formatStatus(status)} size="sm" />}</div></TableRow>
    <TableRow>{children}</TableRow>
  </>);
}

export const AccessibilityTable = ({ children, className }) => {
  return (
    <div className={`grid grid-cols-[1fr,1fr,3fr] body-lg ${className}`}>
      {headers.map((header) => (
        <h3
          key={`args-table-header-${header}`}
          className="border-b-1 border-solid border-fg-moderate pb-5"
        >
          {header}
        </h3>
      ))}
      {children}
    </div>
  );
};

AccessibilityTable.Principle = Principle;

export default AccessibilityTable;
